<template>
  <div id="app" :class="padoff?'paddnone':''">
    <app-header v-if="head"></app-header>
    <router-view></router-view>
    <app-footer v-if="foot"></app-footer>
  </div>
</template>

<script>
function scale(e) {
  var n, r, o = document.querySelector('meta[name="viewport"]'),
  i = document.documentElement.clientWidth;
  n = e,
  r = i / e;
  o.setAttribute("content", "width=" + n + ",initial-scale=" + r + ",maximum-scale=" + r + ",minimum-scale=" + r)

}
scale(750)
   
import Header from '@/components/header'
import Footer from '@/components/footer'
import myhome from '@/components/myhome/myhome'
export default {
  name: 'App',
  data () {
      return {
          head:true,
          padoff:false,
          foot:true
      }
  },
  created:function () {
    let host = window.location.host;
    if(host.indexOf("vue")>-1){
      this.head=false;
      this.padoff=true
      this.foot=false;
    }
  }, 
  components: {
            'app-header': Header,
            'app-footer':Footer,
            'my-home':myhome
        },
  watch: {
    $route: function () {
      window.scrollTo(0, 0)
    }
  }

}
</script>

<style>
*{padding: 0;margin: 0;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 60px;
}
a {
    text-decoration: none;
    color: #000;
}
.paddnone{ padding: 0 !important;}
  @media(max-width: 750px) {
    #app{ padding-top: 110px;}
  }
</style>



// WEBPACK FOOTER //
// src/App.vue